import {sendGetRequest, sendPostRequest} from '../requests';
import {Report, EmbeddingDetails, Visual} from '../../components/reports/types';

const baseUrl = '/reports';

export const getReports = (): Promise<Report[]> => {
  return sendGetRequest(baseUrl);
};

export const getDashboardVisuals = (): Promise<Visual[]> => sendGetRequest(`${baseUrl}/dashboard-visuals`);

export const getEmbeddingDetails = (
    reportId: string,
    groupId: string
): Promise<EmbeddingDetails> => {
  return sendPostRequest(`${baseUrl}/${reportId}/embedding-details?groupId=${groupId}`);
};

export const refreshReportsToken = ({reportId, groupId, datasetId}) => {
  return sendPostRequest(`${baseUrl}/${reportId}/embedding-details/refresh-token?groupId=${groupId}&datasetId=${datasetId}`);
};
